<template>
  <div id="input_delivery">
    <dd-header
      :headerSubContentType=1
      :headerTelContentType=1
    />
    <div id="container">
      <dd-sitemap
        :pageKey="pageKey"
        :pageList="orderForm.pageList"
      />
      <div id="content">
        <div class="title">
          <h2>組立設置情報入力画面</h2>
        </div>
        <div class="input_list">
          <ul>
            <li v-if="orderForm.isCarryIn">
              <span>
                <label class="list_key">{{label.businessName}}</label>
                <label class="important">必須</label>
              </span>
              <input type="text" class="list_box" v-model="form.businessName" maxlength="32"  placeholder="施主名(物件名)・会社名など"/>
              <label v-if="errors.businessName" class="error_text">{{errors.businessName}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.postcd}}</label>
                <label class="important">必須</label>
              </span>
              <input type="text" class="list_box" v-model="form.postcd" v-bind:disabled="form.isNewInput===false" @keypress="validateNumber" @input="form.postcd=inputRestNumber($event)" @blur="addressCompletion" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="0001111"/>
              <label v-if="errors.postcd" class="error_text">{{errors.postcd}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.state}}</label>
                <label class="important">必須</label>
              </span>
              <span class="list_box">
                <input type="text" class="list_box" v-model="form.state" v-bind:disabled="form.isNewInput===false" maxlength="32" placeholder="都道府県"/>
                <input type="text" class="list_box" v-model="form.city" v-bind:disabled="form.isNewInput===false" maxlength="32" placeholder="市区町村"/>
              </span>
              <label v-if="errors.state" class="error_text">{{errors.state}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.street}}</label>
                <label class="important">必須</label>
              </span>
              <input type="text" class="list_box" v-model="form.street" maxlength="32" placeholder="町名"/>
              <label v-if="errors.street" class="error_text">{{errors.street}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.userName}}</label>
                <label class="important">必須</label>
              </span>
              <span class="list_box">
                <input type="text" v-model="form.userLastName" maxlength="32" placeholder="家具"/>
                <input type="text" v-model="form.userFirstName" maxlength="32" placeholder="太郎"/>
              </span>
              <label v-if="errors.userName" class="error_text">{{errors.userName}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.userNameKana}}</label>
                <label class="important">必須</label>
              </span>
              <span class="list_box">
                <input type="text" v-model="form.userLastNameKana" maxlength="32" placeholder="カグ"/>
                <input type="text" v-model="form.userFirstNameKana" maxlength="32" placeholder="タロウ"/>
              </span>
              <label v-if="errors.userNameKana" class="error_text">{{errors.userNameKana}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.tel}}</label>
                <label class="important">必須</label>
              </span>
              <input type="text" class="list_box" v-model="form.tel" maxlength="32" placeholder="0011112222"/>
              <label v-if="errors.tel" class="error_text">{{errors.tel}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.disiredDate}}</label>
                <label class="important">必須</label>
              </span>
            </li>
            <li class="desire desire-top">
              <span>
                <label class="list_key">{{label.desiredDate1st}}</label>
              </span>
              <span class="list_day">
                <template>
                  <dd-calendar
                    :schedule="schedule"
                    :value="form.desiredDate1st"
                    @selectedDate="selectedDate1"
                  />
                </template>
              </span>
              <label v-if="errors.desiredDate1st" class="error_text">{{errors.desiredDate1st}}</label>
            </li>
            <li class="desire">
              <span>
                <label class="list_key">{{label.desiredDate2nd}}</label>
              </span>
              <span class="list_day">
                <template>
                  <dd-calendar
                    :schedule="schedule"
                    :value="form.desiredDate2nd"
                    @selectedDate="selectedDate2"
                  />
                </template>
              </span>
              <label v-if="errors.desiredDate2nd" class="error_text">{{errors.desiredDate2nd}}</label>
            </li>
            <li class="desire">
              <span>
                <label class="list_key">{{label.desiredDate3rd}}</label>
              </span>
              <span class="list_day">
                <template>
                  <dd-calendar
                    :schedule="schedule"
                    :value="form.desiredDate3rd"
                    @selectedDate="selectedDate3"
                  />
                </template>
              </span>
              <label v-if="errors.desiredDate3rd" class="error_text">{{errors.desiredDate3rd}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.homeType}}</label>
                <label class="important">必須</label>
              </span>
              <div>
                <input type="radio" id="homeType1" name="homeType" :value="1" v-model.number="form.homeType"/><label for="homeType1">戸建</label>
                <input type="radio" id="homeType2" name="homeType" :value="2" v-model.number="form.homeType"/><label for="homeType2">マンション・アパート</label>
              </div>
              <label v-if="errors.homeType" class="error_text">{{errors.homeType}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.parkingSpace}}</label>
                <label class="important">必須</label>
              </span>
              <div>
                <input type="radio" id="parkingSpace1" name="parkingSpace" :value="false" v-model="form.parkingSpace"/><label for="parkingSpace1">なし</label>
                <input type="radio" id="parkingSpace2" name="parkingSpace" :value="true" v-model="form.parkingSpace"/><label for="parkingSpace2">あり</label>
              </div>
              <label v-if="errors.parkingSpace" class="error_text">{{errors.parkingSpace}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.message}}</label>
              </span>
              <textarea class="list_box" v-model="form.message" cols="100" rows="5" maxlength="256" placeholder="組立設置時の連絡事項をご記入ください。"/>
            </li>
          </ul>
        </div>
        <section id="construct_confirm">
          <label class="text_size_big bold">確認事項</label>
          <div class="input_list">
            <div class="rule_parts">
              <dd-struct-rule-detial
                @onScrollEnd="onScrollEnd"
              />
            </div>
            <div class="check_box caution_confim">
              <input type="checkbox" id="confirmDelivery" v-model="confirmDelivery" v-bind:disabled="!isScrollEnd"/>
              <label for="confirmDelivery">
                注意事項を確認しました。
              </label>
            </div>
          </div>
        </section>
        <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
        <section id="form_button">
          <div id="regist_btn">
            <button type="submit" class="main_btn cancel_btn" @click="reEdit">戻る</button>
            <button type="submit" class="main_btn" v-bind:disabled="confirmDelivery===false" @click="confirm()">ご注文内容確認</button>
          </div>
        </section>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'

import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as FormUtil from '../../utils/FormUtil'
import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import Calendar from '../../components/common/Calendar'
import LoadingModal from '../../components/common/LoadingModal'

// Module
import Header from '../components/common/DcHeader'
import SiteMap from '../components/common/SiteMap'
import StructRuleDetial from '../components/common/StructRuleDetial'

export default {
  name: 'ConstructInput',
  components: {
    'dd-header': Header,
    'dd-sitemap': SiteMap,
    'dd-loading-modal': LoadingModal,
    'dd-calendar': Calendar,
    'dd-struct-rule-detial': StructRuleDetial
  },
  props: {
  },
  data () {
    return {
      pageKey: 'struct',
      form: {
        businessName: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        tel: '',
        desiredDate1st: '',
        desiredDate2nd: '',
        desiredDate3rd: '',
        homeType: 1,
        parkingSpace: false,
        message: '',
        isNewInput: false
      },
      orderForm: {},
      deliveryForm: {},
      label: {
        businessName: '施主名',
        postcd: '郵便番号',
        state: '設置先住所',
        street: '以下、住所',
        userName: '立会人氏名',
        userNameKana: '立会人氏名（カナ）',
        tel: '立合人電話番号',
        disiredDate: '作業希望日',
        desiredDate1st: '第一希望日',
        desiredDate2nd: '第二希望日',
        desiredDate3rd: '第三希望日',
        homeType: 'ご自宅のタイプ',
        parkingSpace: '駐車スペースの有無',
        message: '組立設置の連絡事項'
      },
      errors: {},
      confirmDelivary: false,
      // IE用の日付
      date1st: {year: '', month: '', day: ''},
      date2nd: {year: '', month: '', day: ''},
      date3rd: {year: '', month: '', day: ''},
      isScrollEnd: true,
      schedule: {},
      delSchedule: {},
      confirmDelivery: false,
      isExistPostcd: false
    }
  },
  methods: {
    scheduling: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          deliveryDate: this.deliveryForm.deliveryDate
        }
      }
      axios.get(DC_URL.SCHEDULE + '/construct', payload)
        .then(response => {
          this.schedule = response.data.data
          this.$refs.loadingModalRef.showModal(false)
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/mmstyle/error')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    selectedDate1: function (selectedDate) {
      let format = 'YYYY-MM-dd'.replace(/YYYY/g, selectedDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (selectedDate.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + selectedDate.getDate()).slice(-2))
      this.form.desiredDate1st = format
    },
    selectedDate2: function (selectedDate) {
      let format = 'YYYY-MM-dd'.replace(/YYYY/g, selectedDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (selectedDate.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + selectedDate.getDate()).slice(-2))
      this.form.desiredDate2nd = format
    },
    selectedDate3: function (selectedDate) {
      let format = 'YYYY-MM-dd'.replace(/YYYY/g, selectedDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (selectedDate.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + selectedDate.getDate()).slice(-2))
      this.form.desiredDate3rd = format
    },
    reEdit: function () {
      this.$router.go(-1)
    },
    fetchData: function () {
      let deliveryData = App.getLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      if (Object.keys(deliveryData).length > 0) {
        this.deliveryForm = Object.assign({}, deliveryData)
      }

      let lorder = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
      if (Object.keys(lorder).length > 0) {
        this.orderForm = Object.assign({}, lorder)
      }

      // 前回の編集内容が残っているか
      let structData = App.getLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
      if (structData && Object.keys(structData).length > 0) {
        // 前回のデータあり
        this.form = Object.assign({}, structData)
        this.isExistPostcd = FormUtil.isExistPostcd(this.form.postcd)
      }
    },
    confirm: function () {
      this.$refs.loadingModalRef.showModal(true)
      // 入力エラーのクリア
      this.errors = {}

      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        return
      }
      this.validateFormat()
      this.validateDate()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        return
      }

      if (this.form.isNewInput && !this.isExistPostcd) {
        this.errors['postcd'] = this.label.postcd + 'が間違っています'
        this.$forceUpdate()
        this.$refs.loadingModalRef.showModal(false)
        return
      }

      // 入力内容をストレージにいれる
      App.setLocalStorage(DC_STORAGE_KEY.STRUCT_DATA, this.form)

      // 確認画面へ
      this.$router.push({
        name: 'OrderConfirm'
      })
      this.$refs.loadingModalRef.showModal(false)
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    },
    addressCompletion: function () {
      FormUtil.addressCompletion(this.form.postcd, (address) => {
        this.$set(this.form, 'state', address.state)
        this.$set(this.form, 'city', address.city)
        this.$set(this.form, 'street', address.street)
        if (this.form.postcd.length > 0 && (!this.form.state || !this.form.city)) {
          this.isExistPostcd = false
        } else {
          this.isExistPostcd = true
        }
      })
    },
    validateDate: function () {
      if (this.form.desiredDate1st === this.form.desiredDate2nd || this.form.desiredDate1st === this.form.desiredDate3rd) {
        this.errors['desiredDate1st'] = this.label.desiredDate1st + 'は他の希望日と別日に設定してください'
      }
      if (this.form.desiredDate2nd === this.form.desiredDate1st || this.form.desiredDate2nd === this.form.desiredDate3rd) {
        this.errors['desiredDate2nd'] = this.label.desiredDate2nd + 'は他の希望日と別日に設定してください'
      }
      if (this.form.desiredDate3rd === this.form.desiredDate1st || this.form.desiredDate3rd === this.form.desiredDate2nd) {
        this.errors['desiredDate3rd'] = this.label.desiredDate3rd + 'は他の希望日と別日に設定してください'
      }
    },
    validateRequire: function () {
      if (this.orderForm.isCarryIn) {
        if (!this.form.businessName) this.errors['businessName'] = this.label.businessName + 'は必須項目です。'
      }
      if (!this.form.postcd) this.errors['postcd'] = this.label.postcd + 'は必須項目です。'
      if (!this.form.state || !this.form.city) this.errors['state'] = this.label.state + 'は必須項目です。'
      if (!this.form.street) this.errors['street'] = this.label.street + 'は必須項目です。'
      if (!this.form.userLastName || !this.form.userFirstName) this.errors['userName'] = this.label.userName + 'は必須項目です。'
      if (!this.form.userLastNameKana || !this.form.userFirstNameKana) this.errors['userNameKana'] = this.label.userNameKana + 'は必須項目です。'
      if (!this.form.tel) this.errors['tel'] = this.label.tel + 'は必須項目です。'
      if (!this.form.desiredDate1st) this.errors['desiredDate1st'] = this.label.desiredDate1st + 'は必須事項です。'
      if (!this.form.desiredDate2nd) this.errors['desiredDate2nd'] = this.label.desiredDate2nd + 'は必須事項です。'
      if (!this.form.desiredDate3rd) this.errors['desiredDate3rd'] = this.label.desiredDate3rd + 'は必須事項です。'
    },
    validateFormat: function () {
      if (!Check.isPostCd(this.form.postcd)) this.errors['postcd'] = this.label.postcd + 'は半角数値で入力してください。'
      if (!Check.isKana(this.form.userLastNameKana) || !Check.isKana(this.form.userFirstNameKana)) this.errors['userNameKana'] = this.label.userNameKana + 'はカタカナで入力してください。'
      if (!Check.isTel(this.form.tel)) this.errors['tel'] = this.label.tel + 'は半角数値で入力してください。'
    },
    onScrollEnd: function () {
      this.isScrollEnd = true
    }
  },
  mounted () {
    this.scheduling()
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/ConstructInput.vue